'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var magicSdk = require('@gig/magic-sdk');
var tslib = require('tslib');

function country(isLockedCountry, converter) {
    var _this = this;
    return {
        id: 'country-wrapper',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'country',
        testId: 'step2-country',
        children: [
            {
                id: 'country',
                component: 'magic-ui-dropdown',
                isDataField: true,
                properties: {
                    // NOTE: we seem to have a race condition issue when
                    // multiple triggers are called after country change
                    // causing the component to be out of sync with the store
                    // and the component value reverts to the default country
                    'keep-alive': true,
                    'placeholder': magicCommon.translate('sign-up-step-two.country.placeholder'),
                    'disabled': isLockedCountry,
                },
                validation: [
                    {
                        name: 'required',
                        fn: magicFormBuilder.required,
                    },
                ],
                preloadProperties: function () { return tslib.__awaiter(_this, void 0, void 0, function () {
                    var countries, currentIPCountry;
                    return tslib.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, magicSdk.magic.invokeCached(60, magicSdk.magic.methods.users, 'getCountries')()];
                            case 1:
                                countries = (_a.sent());
                                return [4 /*yield*/, magicCommon.ipCountryQuery()];
                            case 2:
                                currentIPCountry = _a.sent();
                                return [2 /*return*/, {
                                        options: countries.countries.map(function (_a) {
                                            var name = _a.name, code = _a.code;
                                            return ({
                                                name: name,
                                                value: code,
                                            });
                                        }),
                                        value: currentIPCountry,
                                    }];
                        }
                    });
                }); },
                converter: converter,
            },
        ],
    };
}

exports.country = country;
